<div class="container-fluid" >
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Lista de Asistencia |
          <span style="color: #016E97;">{{nombre_oferta}}</span> - <span style="color: #016E97;">{{uc_pre_impreso}}</span>
        </h3>
      </div>
    </div>
  </div>


  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">
            <!-- Invoice Logo -->
            <div class="row">

              <div class="col-md-6">
                <label for="estadol" class="col-form-label">
                  Seleccione una fecha de asistencia del
                  <span style="color: #016E97;" class="fw-bold">{{fecha_inicio}}</span> al
                  <span style="color: #016E97;" class="fw-bold">{{fecha_fin}}</span>
                </label>
                <div class="input-group">
                  <input
                    class="form-control"
                    placeholder="Fecha asistencia"
                    id="fecha"
                    [readOnly]="true"
                    #fch="ngbDatepicker"
                    ngbDatepicker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [(ngModel)]="fechaSeleccionada"
                    (dateSelect)="asistencias()"
                  >
                  <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fch.toggle()" type="button"></button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="estadol" class="col-form-label">Busqueda</label>
                <input
                  class="form-control"
                  type="text"
                  id="buscar"
                  placeholder="Buscar estudiante..."
                  [(ngModel)]="searchTerm"
                  (input)="buscarAccionFormativa()"
                >
              </div>

            </div>
            <hr class="text-dark">
            <div class="row">
              <div class="col-12">
                <table class="table">
                  <thead>
                    <tr class="table-primary">
                      <th scope="col">N°</th>
                      <th class="text-center">Identificación</th>
                      <th class="text-center">Nombre y Apellido</th>
                      <th>Aistencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of filteredResultado; let i = index">
                      <th scope="row">{{i+1}}</th>
                      <td class="text-center">{{r.identificacion}}</td>
                      <td class="text-center">{{r.nombres_apellidos}}</td>
                      <td>
                        <div class="form-check form-switch">
                          <input  class="form-check-input"  type="checkbox"  id="idAsistencia-{{i}}" [(ngModel)]="r.asistencia" [checked]="r.asistencia">
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


            <div class="row mt-3">
              <div class="col-12 text-center">
                <button type="button" class="btn btn-lg btn-primary" (click)="confirmacion()">Aceptar</button>
              </div>
            </div>
          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>
  <!-- end row -->



</div>





<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje" (saveModal)="guardar_todo()"></app-modal>
